export default function printNumber(
    number: number,
    minimumFractionDigits = 0,
): string {
    const formattedNumber = Math.abs(number).toLocaleString('en-US', {
        minimumFractionDigits,
    });
    return `${number < 0 ? '−' : ''}${formattedNumber}`;
}
